﻿import { Component, OnInit } from '@angular/core';
import { AlertService } from 'app/_services/alert.service';
import { LogService} from 'app/_services/logmanager.service';
import { Router } from '@angular/router';

@Component({
    selector: 'sec-alert',
    templateUrl: 'alert.component.html'
})

export class AlertComponent implements OnInit {
    messages = <any>[];
    loadMessages = <any>[];

    constructor(
        private alertService: AlertService,
        private router: Router
    ) {
        this.messages = [];
        this.loadMessages = [];

        // this.router.events.subscribe(() => {
        //     this.messages = [];
        //     this.loadMessages = [];
        // });
    }

    ngOnInit() {
        this.alertService.getMessage().subscribe(
            message => setTimeout(() => {
                if (message !== undefined) {
                    if (message.type === 'clear') {
                        for (let i = 0; i < this.messages.length; i++) {
                            if (this.messages[i].type !== 'success') {
                                this.messages.splice(i, 1);
                            }
                        }
                    } else if (message.type === 'clearLoading') {
                        if (this.loadMessages.length > 0) {
                            setTimeout(() => this.loadMessages.splice(0, 1), 500);
                        }
                    } else if (message.type === 'loading') {
                        this.loadMessages.push(message);
                    } else {
                        this.messages.push(message);
                    }
                } else {
                    this.messages = [];
                    this.loadMessages = [];
                }
            }, 0),
        );
    }

    close(index: number) {
        LogService.log('AlertComponent', 'Closing alert ' + index);
        this.messages.splice(index, 1);
    }
}
